

export default () => {
  $('.vignette-visor .zoom-icon, .vignette-visor .vignette-img').off('click').click(function(){
    $(this).siblings('.cmp-image-visor').show();
    $('body').css("overflow-y", "hidden");
  });

  $('.vignette-visor .cmp-image-visor .close-icon').off('click').click(function(){
    $(this).parents('.cmp-image-visor').hide();
    $('body').css("overflow-y", "auto");
  });
}
